import { render } from "./Movies.vue?vue&type=template&id=0a552460"
import script from "./Movies.vue?vue&type=script&lang=js"
export * from "./Movies.vue?vue&type=script&lang=js"
script.render = render

export default script